import React from 'react';
import styles from '../Screens/CarInsurance.module.scss';

type Props = {
  heroCard: WebExperienceApiContract.Models.HeroCard
  onClick: () => void
}

const HeroCard = ({ heroCard, onClick }: Props) => {
    if (!heroCard) return null;
    return (
      <div
        className={`${styles.bg} align-bottom`}
        style={{ backgroundImage: `url(${heroCard.imageHeroCard.url})` }}
        onKeyDown={onClick}
        role="button"
        tabIndex={0}
        onClick={onClick}
      >
        <div className={`${styles.bgText} align-bottom bg-dark `}>{heroCard.termsAndConditions}</div>
      </div>
    );
};
export default HeroCard;
